import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect } from "react";
import logo from "../../images/logo.png";
import { MainContainer, MainContent } from "../DataEntry/StyledFields";
import { SystemMessages } from "../../common/Constants";

const ThankYouForApplying = (props) => {
  useEffect(() => {
    console.log("ThankYouForApplying component");
  }, []);

  return (
    <MainContainer>
      <MainContent>
        <Box sx={{ my: 4, width: "100%", textAlign: "center" }}>
          <img src={logo} width="200px" alt="logo" />
        </Box>
        <Box sx={{ width: "600px", margin: "0 auto" }}>
          <Typography variant="body1">
            {SystemMessages.PAYMENT_RECEIVED}{" "}
            <a
              href="https://new-eyes.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Click here
            </a>{" "}
            to visit our home page.
          </Typography>
        </Box>
      </MainContent>
    </MainContainer>
  );
};

export default ThankYouForApplying;
